const n = (e, t) => {
  const o = t || (navigator == null ? void 0 : navigator.language), i = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(o, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: i
  }).format(e);
}, a = (e, t) => {
  const o = t || navigator.language, i = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(o, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: i
  }).format(e);
}, r = (e, t) => {
  const o = t || navigator.language, i = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(o, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: i
  }).format(e);
}, m = (e, t) => {
  const o = t || navigator.language, i = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(o, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: i
  }).format(e);
}, s = (e, t) => {
  const o = t || navigator.language;
  return new Intl.DateTimeFormat(o, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: !0
  }).format(e);
};
export {
  n as formatDate,
  r as formatDateTime,
  s as formatLongDateTime,
  m as formatMediumDateTime,
  a as formatTime
};
